module.exports = __webpack_public_path__ + "img/sidebar-background-essilor.cb27526d.jpg";